module.exports = __webpack_public_path__ + "media/images/dashboard/light/tile_icon_stats_tiles-b4c1667fd8444eb6802ac4ef8ec9e1bf.png";